import { Component, OnInit } from '@angular/core';

import { Funciones } from '../../../../shared/funciones';
import { LibreriaApi, BlogApi } from '../../../../shared/sdk';

@Component({
  selector: 'app-front-footer',
  templateUrl: './frontend-footer.component.html',
  styleUrls: ['./frontend-footer.component.css']
})
export class FrontFooterComponent implements OnInit {
  public articulo: any;
  public noticias: any;
  public now: Date = new Date();
  public cookieAccept = false;

  constructor(public funciones: Funciones, public libreriaapi: LibreriaApi, public blogapi: BlogApi) { }

  ngOnInit() {
    this.libreriaapi.getRandomArticle().subscribe((res: any) => {
      res.imagen = res.portada ? this.funciones.builImgLink(res.portada) : './assets/imgs/sin-portada.png';
      this.articulo = res;
    });
    this.blogapi.getLatestNews().subscribe(res => {
      this.noticias = res;
    });
    const temp = window.localStorage.getItem('fxa-cookie-accept');
    if (temp) {
      this.cookieAccept = true;
    }
  };

  cookieAcceptSave() {
    window.localStorage.setItem('fxa-cookie-accept', "1");
    this.cookieAccept = true;
  };

}



// WEBPACK FOOTER //
// ./src/app/modules/frontend/generic/frontend-footer/frontend-footer.component.ts